module.exports = __webpack_public_path__ + "img/jiugongmiao.498bffdd.png";